import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@shared/auth/auth-guard';
import { AdminComponent } from './admin.component';
import { EmailAdminComponent } from './emailAdmin/emailAdmin.component';
import { ComplaintAdminComponent } from './complaintAdmin/complaintAdmin.component';
import { BusinessAdminComponent } from './businessAdmin/businessAdmin.component';
import { MergeBusinessComponent } from './businessAdmin/mergeBusiness/mergeBusiness.component';
import { RolesComponent } from './roles/roles.component';
import { UsersComponent } from './users/users.component';



const routes: Routes = [
  { path: 'admin', component: AdminComponent, canActivate: [ AuthGuard ] },
  { path: '', component: AdminComponent, canActivate: [ AuthGuard ] },
  { path: 'emailAdmin', component: EmailAdminComponent, canActivate: [ AuthGuard ] },
  { path: 'complaintAdmin', component: ComplaintAdminComponent, canActivate: [ AuthGuard ] },
  { path: 'businessAdmin', component: BusinessAdminComponent, canActivate: [ AuthGuard ] },
  { path: 'mergeBusiness', component: MergeBusinessComponent, canActivate: [ AuthGuard ] },
  { path: 'roles', component: RolesComponent, canActivate: [ AuthGuard ] },
  { path: 'users', component: UsersComponent, canActivate: [ AuthGuard ] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [
  ]
})

export class AdminRoutingModule { }

